import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { advertismentCommand } from '../../model/const/command';
import { LettingAdvertismentParkingService } from '../letting-advertisment-parking.service';

@Injectable()
export class SendToPlatformParkingCommandHandler implements ICommandHandler {
  constructor(private _advertService: LettingAdvertismentParkingService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === advertismentCommand.sendToPlatform && command.context;
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      return this._advertService.sendToPlatform(command.context.id);
    }
  }
}
